var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 170,
    viewBox: "0 0 65 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_5177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 -1.83366e-06L0 0L10.4873 10.4873L20.9746 -1.83366e-06Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 35.5391L0 35.5391L10.4873 46.0264L20.9746 35.5391Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 71.0937L0 71.0938L10.4873 81.581L20.9746 71.0937Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 106.633L0 106.633L10.4873 117.12L20.9746 106.633Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 142.168L0 142.168L10.4873 152.67L20.9746 142.168Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 17.2773L44.0254 17.2773L54.5127 27.7646L65 17.2773Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 52.832L44.0254 52.832L54.5127 63.3193L65 52.832Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 88.3711L44.0254 88.3711L54.5127 98.8584L65 88.3711Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 123.91L44.0254 123.91L54.5127 134.397L65 123.91Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 159.461L44.0254 159.461L54.5127 169.948L65 159.461Z",
    fill: "#0593A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_5177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 169.949,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDownArrow);
export default __webpack_public_path__ + "static/media/bg-down-arrow.7904e1a70b2164efacd5a2312e0bc381.svg";
export { ForwardRef as ReactComponent };